"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWeather = function IconWeather(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m5.804 6.555-.259.966 3.215.862 1.613 2.794H7.061L4.707 8.823 4 9.53l1.646 1.647H2v2h3.646L4 14.823l.707.707 2.354-2.353h3.293L8.73 15.99l-3.215.862.258.966 2.25-.603-1.793 3.106 1.732 1 1.793-3.106.602 2.25.966-.26-.861-3.214 1.634-2.83 1.634 2.83-.862 3.215.966.258.603-2.249 1.793 3.105 1.732-1-1.793-3.105 2.249.603.259-.966-3.215-.861-1.625-2.814H17l2.354 2.353.707-.707-1.647-1.646H22v-2h-3.586l1.647-1.647-.707-.707L17 11.177h-3.182l1.613-2.794 3.215-.862-.258-.966-2.25.603L17.963 4 16.23 3l-1.824 3.158-.602-2.25-.966.26.861 3.215-1.603 2.777-1.604-2.777.862-3.215-.966-.26-.603 2.25L7.962 3 6.23 4l1.823 3.158z",
    clipRule: "evenodd"
  })));
};

export { IconWeather, IconWeather as default };
